import clsx from 'clsx';

interface Props {
    customStyle: 'in-store-services-overview' | 'online-orders-overview';
    children: React.ReactNode;
}

const WrapperOverview = ({ customStyle, children }: Props): JSX.Element => {
    return (
        <div
            className={clsx(
                customStyle === 'in-store-services-overview' && 'overview--in-store-services',
                customStyle === 'online-orders-overview' && 'overview--online-orders-overview'
            )}
        >
            {children}
        </div>
    );
};
export default WrapperOverview;
